<div class="sidebar-selection-behavior">
  <label for="sidebar-selection-behavior_select">{{ 'SelectionBehaviorLabel' | transloco }}:</label>
  <tt-form-field class="sidebar-selection-behavior_select" id="sidebar-selection-behavior_select">
    @if (!guidelineComponent) {
      <tt-select [ngModel]="sidebarElement.selectionBehaviorForChildren" (ngModelChange)="onSelectionBehaviorChange($event)">
        <tt-select-items>
          <tt-option [value]="1">{{ SelectionBehavior[SelectionBehavior.And] | transloco }}</tt-option>
          <tt-option [value]="2">{{ SelectionBehavior[SelectionBehavior.ExactlyOne] | transloco }}</tt-option>
          <tt-option [value]="3">{{ SelectionBehavior[SelectionBehavior.OneOrMore] | transloco }}</tt-option>
        </tt-select-items>
      </tt-select>
    }
    @if (guidelineComponent) {
      <tt-select [ngModel]="guidelineComponent.selectionBehaviorForChildren" (ngModelChange)="onSelectionBehaviorChange($event)">
        <tt-select-items>
          <tt-option [value]="1">{{ SelectionBehavior[SelectionBehavior.And] | transloco }}</tt-option>
          <tt-option [value]="2">{{ SelectionBehavior[SelectionBehavior.ExactlyOne] | transloco }}</tt-option>
          <tt-option [value]="3">{{ SelectionBehavior[SelectionBehavior.OneOrMore] | transloco }}</tt-option>
        </tt-select-items>
      </tt-select>
    }
  </tt-form-field>
</div>
